var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('van-row',{attrs:{"type":"flex","justify":"center"}},[_c('van-col',{attrs:{"span":"24","align":"center"}},[_c('router-view')],1)],1),(_vm.showTabBar)?_c('TabBar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }